export default {"src":"/_next/static/media/fullscreen.99801f0e.svg","height":21,"width":20};